import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Mint from 'mint-ui'
import config from './config'
import init from '@ivy/fts'
import router from './router'
import store from './store'
import directiveInstall from './directives'

init({ Vue, router, axios, config, Mint, openSentry: true })
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.config.productionTip = false
directiveInstall(Vue)

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app-box')
